/* Copyright (c) 2020 Pej AB. All rights reserved.
 * Created by Marcus Johansson on 2020-02-11. */

export class PejDevice {
    public app: string;
    public connected: boolean;
    public device: any;
    public filters: any;
    public id: string;
    public printers: any;
    public profile: string;
    public timeDisconnected: number;

    public setStringId(id: string) {
        this.id = id;
    }
}
